import {withInstall} from "@verdure/core";
// @ts-ignore
import TOrderList from './src/Index.vue'

// 微信订单列表
TOrderList.name = 'verdure-order-list';
export const WechatOrderList = withInstall(TOrderList);
